(function () {
        var karta = document.currentScript.closest('[data-studio-karta]');
        if (!karta) { return; }
        var parametr = '_studio_live';
        var url = new URL(window.location.href);
        var poPrzeladowaniu = url.searchParams.has(parametr);
        var poprzedniaGranica = Number((url.searchParams.get(parametr) || '').split('.')[0]);
        if (url.searchParams.has(parametr)) {
            url.searchParams.delete(parametr);
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        }
        var granica = Date.parse(karta.getAttribute('data-studio-przeladuj'));
        if (!Number.isFinite(granica)) { return; }
        // URL also carries the boundary, so stale HTML cannot loop when
        // sessionStorage is blocked. A different next boundary still runs.
        if (poPrzeladowaniu && poprzedniaGranica === granica) { return; }
        // A client clock ahead of the server must not cause a reload loop.
        // Elapsed time uses a monotonic clock; cached HTML gets at most one
        // immediate refresh per boundary in this tab.
        var serwer = Date.parse(karta.getAttribute('data-studio-czas'));
        var start = performance.now();
        var baza = Number.isFinite(serwer) ? serwer : Date.now();
        var blokada = 'pewniaki:studio-granica:' + granica;
        try { if (sessionStorage.getItem(blokada)) { return; } } catch (e) {}
        if (poPrzeladowaniu && !Number.isFinite(serwer) && Date.now() >= granica) { return; }
        var zrobione = false;
        function odswiez() {
            if (zrobione || baza + performance.now() - start < granica) { return; }
            zrobione = true;
            try { sessionStorage.setItem(blokada, '1'); } catch (e) {}
            var swiezy = new URL(window.location.href);
            swiezy.searchParams.set(parametr, String(granica) + '.' + String(Date.now()));
            window.location.replace(swiezy.toString());
        }
        var opoznienie = Math.max(0, granica - baza);
        window.setTimeout(odswiez, Math.min(opoznienie, 2147483000));
        window.setInterval(odswiez, 1000);
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') { odswiez(); }
        });
        window.addEventListener('pageshow', odswiez);
    })();
